<template>
  <div style="color: #333333">
    <a-row>
      <a-col :span="8">
        <a-descriptions
          :column="1"
          class="custom-descriptions custom-descriptions-max-7"
        >
          <a-descriptions-item label="订单号">
            {{ order.order_no }}
          </a-descriptions-item>
          <a-descriptions-item label="订单类型">
            {{ order.record_type_display }}
          </a-descriptions-item>
          <a-descriptions-item label="状态">
            {{ order.order_status }}
          </a-descriptions-item>
          <a-descriptions-item label="订单来源">
            {{ order.source }}
          </a-descriptions-item>
          <a-descriptions-item label="负责人">
            {{ order.head_name }}
          </a-descriptions-item>
          <a-descriptions-item label="创建时间">
            {{ order.created_at }}
          </a-descriptions-item>
        </a-descriptions>
      </a-col>

      <a-col :span="8">
        <a-descriptions
          :column="1"
          class="custom-descriptions custom-descriptions-max-7"
        >
          <a-descriptions-item label="申请人">
            {{ order.apply_name }}
          </a-descriptions-item>
          <a-descriptions-item label="联系电话">
            {{ order.phone_number }}
          </a-descriptions-item>
          <a-descriptions-item label="丧属">
            {{ order.masterName }}
          </a-descriptions-item>
          <a-descriptions-item label="联系电话">
            {{ order.masterPhone }}
          </a-descriptions-item>
        </a-descriptions>
      </a-col>
      <a-col :span="8">
        <a-descriptions
          :column="1"
          class="custom-descriptions custom-descriptions-max-7"
        >
          <a-descriptions-item label="服务地点">
            {{ order.origination }}
          </a-descriptions-item>
          <a-descriptions-item label="备注">
            {{ order.remark }}
          </a-descriptions-item>
        </a-descriptions>
      </a-col>
    </a-row>
    <a-divider />

    <a-row>
      <a-col span="12">
        <a-descriptions
          :column="1"
          class="custom-descriptions custom-descriptions-max-7"
        >
          <a-descriptions-item label="套餐金额">
            <span style="word-break: break-all">{{ order.package_fee }}元</span>
          </a-descriptions-item>
          <a-descriptions-item label="其他项目金额">
            <span
              style="word-break: break-all"
            >{{ order.other_item_fee }}元</span>
          </a-descriptions-item>
          <a-descriptions-item label="优惠金额">
            <a-space>
              <span style="word-break: break-all">{{ order.voucher_fee }}元</span>
            </a-space>
          </a-descriptions-item>

          <a-descriptions-item label="结算金额">
            <span style="word-break: break-all">{{ order.settle_fee }}元</span>
            <span v-if="order.adjust" style="margin-left: 10px;color: red;">(调账)</span>
          </a-descriptions-item>
          <a-descriptions-item label="已实际支付金额">
            <a-space>
              <span style="word-break: break-all">{{ order.paid_fee }}元</span>
            </a-space>
          </a-descriptions-item>

          <a-descriptions-item label="剩余应付金额">
            <span style="word-break: break-all">{{ order.unpaid_fee }}元</span>
          </a-descriptions-item>
          <a-descriptions-item label="应退金额">
            <span style="word-break: break-all">{{ order.withdrawn_fee }}元</span>
          </a-descriptions-item>
        </a-descriptions>
      </a-col>
      <a-col span="12">
        <qrcode-vue
          v-if="order.qr_code_url"
          :value="order.qr_code_url"
          :size="200"
          level="H"
        />
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { findServiceOrder } from '@/api/service_order'

export default {
  name: 'BasicInformation',
  components: {
    QrcodeVue: () => import('qrcode.vue')
  },
  props: {
    serviceOrderId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      order: {}
    }
  },
  computed: {
    isShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      findServiceOrder(this.serviceOrderId).then((res) => {
        this.order = res.data
      })
    },

    closeModal() {
      this.isShow = false
    }
  }
}
</script>

